<template>
    <div class="w-100 m-0 d-flex justify-content-center">
        <div class="container-inputs p-3">
            <Breadcrumbs :breadcrumbs="breadcrumbs" />

            <h1 class="display-4 text-white fw-normal title">{{ title ?? '&nbsp;' }}</h1>
            <hr />

            <p class="p-3 bg-light text-dark rounded-2 small">
                <i class="fa fa-info-circle me-1"></i> Dit is het bedrag dat je op dit moment hebt gespaard. Oftewel het totaalbedrag van je maandelijkse inleg, verminderd met de kosten van je {{ !isCrowdsurance() ? 'producten' : 'crowdsurance product' }}.
            </p>

            <div class="row row-cols-md-2 row-cols-1 mt-2">
                <div class="col mb-md-0 mb-2">
                    <router-link to="/saldo/withdraw" class="btn btn-primary"><i class="fa fa-euro-sign me-1"></i> Saldo opnemen</router-link>
                </div>
            </div>

            <h4 class="display-6 text-white mt-3 fw-normal">Huidig saldo</h4>

            <h3 class="mb-0 p-3 bg-trans display-1 text-light rounded-4 display-1 position-relative">
                <div>
                    <span :class="['d-block max-balance', loadedBalance ? 'text-white' : 'text-transparent'] " id="balance">
                        {{ this.$numberFormatEuro(totalSaldo) }}
                    </span>
                </div>

                <div>
                    <img src="@/assets/icons/loading.png" alt="Loading icon" class="loading-icon">
                </div>
            </h3>

            <h4 class="display-6 text-white mt-3 fw-normal">Saldoverloop</h4>

            <div class="row m-0 p-0 position-relative justify-content-center w-100 line-chart">
                <Line :data="chartData" :options="chartOptions" :key="compKey" style="height:min(100vw,80vh,400px);"/>
                <i class="fa fa-circle-notch fa-spin"></i>
                <!-- <p class="position-middle rounded-2 p-3 small bg-info text-dark no-results-period"><i class="fa fa-info-circle me-1"></i> Er zijn geen resultaten voor deze periode.</p> -->
            </div>

            <div class="row row-cols-1 mt-2">
                <div class="col"><h5 class="text-white">Terugkijken</h5></div>
                <div class="col">
                    <select class="form-select" id="monthsSelection" @change="getCustomerData">
                        <option v-for="[key, value] in Object.entries(monthOptions)" :value="value" :key="key">{{ key }}</option>
                    </select>
                </div>
                
            </div>

            
            <h4 class="display-6 text-white mt-3 fw-normal">Maandoverzicht</h4>

            <table class="table position-relative" id="monthTable">
                <thead>
                    <tr>
                        <th class="text-white px-0 px-md-2" id="currentMonth"></th>
                        <th class="text-white px-0 px-md-2 text-end">Bedrag</th>
                    </tr>
                </thead>
                <tbody>
                        <tr :class="['position-relative']">
                            <td class="no-border px-0 px-md-2 text-white fw-md-normal">Inleg</td>
                            <td class="no-border px-0 px-md-2 text-white text-md-end text-end" id="paymentAmount"></td>
                        </tr>

                        
                        <tr :class="['position-relative']">
                            <td class="no-border px-0 px-md-2 text-white fw-md-normal">Schenkingen</td>
                            <td class="no-border px-0 px-md-2 text-white text-end" id="payoutGivenAmount"></td>
                        </tr>

                        
                        <tr :class="['position-relative']">
                            <td class="no-border px-0 px-md-2 text-white fw-md-normal">Pensioeninleg</td>
                            <td class="no-border px-0 px-md-2 text-white text-end" id="retirementAmount"></td>
                        </tr>

                        
                        <tr :class="['position-relative']">
                            <td class="no-border px-0 px-md-2 text-white fw-md-normal">Uitbetalingsverzoek</td>
                            <td class="no-border px-0 px-md-2 text-white text-end" id="payoutRequestAmount"></td>
                        </tr>

                        
                        <tr :class="['position-relative']">
                            <td class="no-border px-0 px-md-2 text-white fw-md-normal">Kosten</td>
                            <td class="no-border px-0 px-md-2 text-white text-end" id="costsAmount"></td>
                        </tr>
                        
                        <tr :class="['position-relative']">
                            <td class="no-border px-0 px-md-2 text-white fw-md-normal">Overig</td>
                            <td class="no-border px-0 px-md-2 text-white text-end" id="otherAmount"></td>
                        </tr>
                        
                        <tr :class="['position-relative']">
                            <td class="no-border px-0 px-md-2 text-white fw-bold">Totaal</td>
                            <td class="no-border px-0 px-md-2 text-white text-end fw-bold" id="totalAmount"></td>
                        </tr>
                </tbody>
            </table>

            <div class="btn btn-primary mb-3" id="previousMonth"><i class="fas fa-chevron-left"></i>  Maand eerder</div>
            <div class="btn btn-primary mb-3 float-end disabled" id="nextMonth">Maand later <i class="fas fa-chevron-right"></i></div>

            <h4 class="display-6 text-white mt-3 fw-normal">Transactieoverzicht</h4>
            <div class="btn btn-primary mb-3" @click="toggleTransactions"><i class="fa fa-list-alt"></i> {{ isOpen ?
                'Transactieoverzicht verbergen' : 'Transactieoverzicht bekijken' }}</div>

            <div id="transactions" class="position-relative w-100" style="display: none;">
                <div v-if="transactions.length > 0">
                    <table class="table position-relative">
                        <thead>
                            <tr>
                                <th class="text-white px-0 px-md-2">Transactie datum</th>
                                <th class="text-white px-0 px-md-2 text-center text-md-end">Bedrag</th>
                                <th class="text-white px-0 px-md-2 text-end">Saldo na transactie</th>
                            </tr>
                        </thead>
                        <tbody>
                            <template v-for="transaction in transactions" :key="transaction.date">
                                <tr :class="['position-relative', loadingTransactions ? 'opacity-0' : '']">
                                    <td class="no-border px-0 px-md-2 text-white fw-md-normal fw-bold">{{$formatDate(transaction.expected_at)}}</td>
                                    <td class="no-border px-0 px-md-2 text-white text-md-end text-center">{{this.$numberFormatEuro(parseFloat(transaction.sum_amount))}}</td>
                                    <td class="no-border px-0 px-md-2 text-white text-end">
                                        <span class="fw-normal" v-if="transaction.saldo_after_grouped_customer">{{ this.$numberFormatEuro(transaction.saldo_after_grouped_customer) }}</span>
                                        <i v-if="transaction.saldo_after_grouped_customer == null" class="fa fa-hourglass-half"></i>
                                        <i :class="['middle-ver d-none d-sm-inline-block ms-2', transaction.sum_amount > 0 ? 'text-info far fa-arrow-alt-circle-up' : 'text-danger far fa-arrow-alt-circle-down']"></i>
                                    </td>
                                </tr>
                                <tr :class="['position-relative', loadingTransactions ? 'opacity-0' : '']">
                                    <td :class="['text-white border-subtle px-0 px-md-2 pt-0 small', loadingTransactions ? 'border-transparent' : '']" colspan="3">{{ transaction.description }}</td>
                                </tr>
                            </template>
                        </tbody>
                    </table>
                    
                    <!-- Pagination -->
                    <Pagination :pagination="transactionPagination" :currentPaginationPage="currentPaginationPage" @updatePagination="(url, label) => fetchTransactions(url, label)"/>
                </div>

                <p v-else class="p-3 rounded-2 small bg-info text-dark"><i class="fa fa-info-circle me-1"></i> Er zijn geen resultaten gevonden</p>
            </div>
        </div>
    </div>
</template>

<style scoped>
.no-border, .border-subtle {
    border-color: rgba(255, 255, 255, 0.25);
}

.no-border {
    border-color: transparent;
}

.crowdsurance > span.max-balance {
    font-family: "Intro Regular", sans-serif;
}

.position-middle {
    position: absolute;
    left: calc(50% - 100px);
    top: calc(50% - 37.5px);
    width: 200px;
    height: 75px;
}

.border-transparent {
    border-color: transparent;
}

span {
    transition: color 500ms;
}

hr {
    border-color: rgba(255, 255, 255, 0.5);
}

.hide {
    max-height: 0;
}

table tr td,
table tr,
th {
    background-color: transparent !important;
}

.crowdsurance table tr td,
.crowdsurance tr,
.crowdsurance th {
    color: var(--crowdsurance-header) !important;
}

.fa-circle-notch {
    font-size: 128px;
    position: absolute;
    left: calc(50% - 64px);
    top: calc(50% - 64px);
    color: #fff;
    transform-origin: 76px;
}

.loading-icon {
    filter: brightness(2000%);
    position: absolute;
    width: 1em;
    height: 1em;
    animation: spinning 2s ease-in-out infinite;
    top: calc(50% - 0.5em);
    transform-origin: 50%;
}

@keyframes spinning {
    0% {
        transform: rotateZ(0);
    }

    100% {
        transform: rotateZ(360deg);
    }
}

.bg-trans {
    background-color: rgba(0, 0, 0, 0.2);
    display: block;
}

.text-transparent {
    color: transparent;
}

tr {
    transition: opacity var(--transition-400ms) ease-in-out;
}

td {
    transition: border-color var(--transition-400ms) ease-in-out;
}

.bg-green {
    background-color: var(--light-green);
}

.middle-ver {
    top: calc(50% - 0.5em);
    right: 0.3em;
}

.bg-no-balance {
    background-color: rgba(255, 199, 199);
}
</style>

<script type="text/javascript">
const FADE_SPEED = 200;
const CURRENT_DATE = new Date();

const DATE_STRING = [CURRENT_DATE.getFullYear(), ('0' + (CURRENT_DATE.getMonth() + 1)).slice(-2), ('0' + CURRENT_DATE.getDate()).slice(-2)].join('-');

import $ from 'jquery';
import { Breadcrumb, getCustomer, isKnab, updateAppearanceKnab } from '@/App.vue';
import Breadcrumbs from '@/components/BreadcrumbsComponent.vue';
import Pagination from '@/components/PaginationComponent.vue';
import {
  Chart as ChartJS,
  TimeScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Colors
} from 'chart.js'
import { Line } from 'vue-chartjs'
import 'chartjs-adapter-moment';
import moment from 'moment';

ChartJS.register(
  TimeScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Colors,
)

ChartJS.defaults.color = isKnab() ? "#003B5A" : "#fff";
ChartJS.defaults.font.family = "Lato";

export default {
    name: 'saldo-component',
    components: {
        Breadcrumbs,
        Line,
        Pagination
    },
    data() {
        return {
            payoutAmount: null,
            isOpen: false,
            breadcrumbs: [new Breadcrumb("/saldo", isKnab() ? 'Mijn buffer' : 'Mijn spaarpot' )],
            loadedBalance: false,
            transactions: [],
            transactionPagination: [],
            currentPaginationPage: '1',
            loadingTransactions: false,
            participants: [],
            current_brand_id: undefined,
            totalSaldo: 0,
            compKey: 0,
            now: new Date(),
            updatingMonth: false,
            transactionProcesses: {
                "payout": "Uitbetaling",
                "directdebit": "Incasso",
                "internal": "Intern"
            },
            monthOptions: {
                "6 maanden": 6,
                "1 jaar": 12,
                "2 jaar": 24,
                "5 jaar": 60
            },
            chartOptions: {
                responsive: true,
                maintainAspectRatio: true,
                plugins: {
                    legend: {
                        display: false,
                    },
                    colors: {
                        enabled: true
                    },
                },
                scales: {
                    x: {
                        type: 'time',
                        offset: true,
                        time: {
                            unit: 'day',
                            displayFormats: {
                                day: 'MMM \'YY',
                            },
                            tooltipFormat: 'DD-MM-YYYY',
                        },
                        title: {
                            display: true,
                            text: 'Maand'
                        },
                        ticks: {
                            callback: function(value) {
                                const date = moment(value);

                                //if(date.startOf('day').isSame(moment().startOf('day'), 'day')) {
                                if(date.startOf('day').isSame(moment(DATE_STRING).startOf('day'), 'day')) {
                                        return 'Huidig saldo';
                                } else if (date.date() == 1) {
                                    return date.format('01-MM-\'YY');
                                }
                                return '';
                            },
                            align: 'center',
                            autoSkip: false,
                            source: 'data',

                            maxRotation: 90,
                            minRotation: 90,
                            padding: 5,
                        },
                        grid: {
                            drawTicks: true,
                            // tickColor: 'rgba(0, 0, 0, 0.1)',
                            color: function(context) {
                                const date = moment(context.tick.value);
                                return date.date() === 1 ? (isKnab() ? "rgba(0, 59, 90, 0.3)" : "rgba(255, 255, 255, 0.3)") : 'transparent';
                            },
                            borderColor: isKnab() ? "rgba(0, 59, 90, 0.3)" : "rgba(255, 255, 255, 0.3)",
                        }
                    },
                    y: {
                        beginAtZero: false,
                        title: {
                            display: true,
                            text: 'Saldo'
                        },
                        grid: {
                            color: isKnab() ? "rgba(0, 59, 90, 0.3)" : "rgba(255, 255, 255, 0.3)",
                            borderColor: isKnab() ? "rgba(0, 59, 90, 0.3)" : "rgba(255, 255, 255, 0.3)",
                        }
                    }
                }
            },
            chartData: {
                labels: {},
                datasets: [
                    {}
                ],
            },
            title: undefined,
            info: undefined,
        }
    },
    methods: {
        isCrowdsurance() {
            return isKnab();
        },
        month(month) {
            let months = ['Januari', 'Februari', 'Maart', 'April', 'Mei', 'Juni', 'Juli', 'Augustus', 'September', 'Oktober', 'November', 'December'];
            return months[month];
        },
        async fetchTransactions(url = "", label = "") {
            if(label === "...")
                return;

            if((label === "<" || label === ">") && url === null)
                return;

            this.loadingTransactions = true;
            let http = url !== "" ? url : 'transactions';

            this.$http.get(http)
                .then((response) => {
                    if(response.data.current_page)
                        this.currentPaginationPage = response.data.current_page.toString();
                    setTimeout(() => {
                        if(response.data.data) {
                            this.loadingTransactions = false;
                            this.transactions = response.data.data;
                            this.transactionPagination = response.data.links;
                            this.compKey++;

                            $(".line-chart").fadeIn(400);

                            // Verander labels voor vorige en volgende
                            this.transactionPagination[0].label = "<";
                            this.transactionPagination[this.transactionPagination.length - 1].label = ">";

                            $(".loading-icon").fadeOut("fast");

                            if(isKnab()) {
                                $(".text-white").removeClass("text-white");
                                $("#balance").addClass("text-white");
                            }
                        }
                    }, 250);
                });
        },
        async getCustomerData() {
            if(this.participants.length === 0)
                return;
            
            $(".fa-circle-notch").fadeIn(300);

            let query = `/${$("#monthsSelection").find(":selected").val()}`;
            await this.$http.get('transactions/saldo_flow' + query)
                .then((response) => {
                    $(".fa-circle-notch").fadeOut(300);

                    this.chartData = response.data;
                    $(".no-results-period").fadeIn("slow");
                    this.chartData.datasets.forEach((element) => {
                        if(element.data.length > 0)
                            $(".no-results-period").fadeOut(0);
                    });
                    for(let i = 0; i < this.chartData.datasets.length; i++) {
                        this.chartData.datasets[i].backgroundColor = isKnab() ? "rgba(0, 59, 90, 1)" : "rgba(255, 255, 255, 1)";
                        this.chartData.datasets[i].borderColor = isKnab() ? "rgba(0, 59, 90, 1)" : "rgba(255, 255, 255, 1)";
                    }
                    this.fetchTransactions();

                    this.totalSaldo = response.data.saldo;
                });

            if(isKnab()) {
                $(".text-white").removeClass("text-white");
                updateAppearanceKnab();
            }
        },
        toggleTransactions() {
            $("#transactions").toggle("fast");
            this.isOpen = !this.isOpen;
        },
        numberFormatEur(amount, decimals = 2) {
            return new Intl.NumberFormat('nl-NL', {
                style: 'currency',
                currency: 'EUR',
                maximumFractionDigits: decimals, 
                minimumFractionDigits: decimals,
            }).format(amount).replace(/\s/g, '');
        },
        async updateMonths(direction) {
            // Verander de maand
            this.now.setMonth(this.now.getMonth() + direction);
            $("#currentMonth").text(`${this.month(this.now.getMonth())} ${this.now.getFullYear()}`);

            if(this.now.getMonth() === CURRENT_DATE.getMonth() && this.now.getFullYear() === CURRENT_DATE.getFullYear()) {
                $("#nextMonth").addClass("disabled");
            } else {
                $("#nextMonth").removeClass("disabled");
            }
        
            await this.$http.get(`/monthly_report/${this.now.getFullYear()}-${('0' + (this.now.getMonth() + 1)).slice(-2)}-01`)
                .then((response) => {
                    ['#payoutGivenAmount', '#paymentAmount', '#retirementAmount', '#payoutRequestAmount', '#costsAmount', '#otherAmount', '#totalAmount'].forEach((el) => {
                        $(el).text(this.$numberFormatEuro(0));
                    });

                    let data = response.data;
                    if(data.payment)
                        $("#paymentAmount").text(`${this.$numberFormatEuro(data.payment, 2)}`);
                    if(data.payout_given)
                        $("#payoutGivenAmount").text(`${this.$numberFormatEuro(data.payout_given, 2)}`);
                    if(data.payout_request)
                        $("#payoutRequestAmount").text(`${this.$numberFormatEuro(data.payout_request, 2)}`);
                    if(data.retirement)
                        $("#retirementAmount").text(`${this.$numberFormatEuro(data.retirement, 2)}`);
                    if(data.costs)
                        $("#costsAmount").text(`${this.$numberFormatEuro(data.costs, 2)}`);
                    if(data.other)
                        $("#otherAmount").text(`${this.$numberFormatEuro(data.other, 2)}`);
                    if(data.total)
                        $("#totalAmount").text(`${this.$numberFormatEuro(data.total, 2)}`);

                    $("#monthTable").fadeTo(FADE_SPEED, 1);
                });
        }
    },
    async mounted() {
        this.updateMonths(0);
        this.title = isKnab() ? 'Mijn buffer' : 'Mijn spaarpot';
        this.info = 'Dit is het bedrag dat je op dit moment hebt gespaard. Oftewel het totaalbedrag van je maandelijkse inleg, vermindert met de kosten van je producten.';

        $("#currentMonth").text(`${this.month(this.now.getMonth())} ${this.now.getFullYear()}`);

        $(".fa-circle-notch").fadeOut(0);
        $(".change-participant").hide();
        $(".line-chart").fadeOut(0);
        $(".no-results-period").fadeOut(0);

        let customer = getCustomer();
        if(customer)
            this.current_brand_id = customer.current_brand_id;

        if(isKnab()) {
            updateAppearanceKnab();
            ChartJS.defaults.color = "#003B5A";
            ChartJS.defaults.font.family = "PT Sans";
            $(".fa-circle-notch").css("color", "#003b5a");
        }

        await this.$http.get('/participants/all')
            .then((response) => {
                this.totalSaldo = 0;
                for(let i = 0; i < response.data.length; i++) {
                    const feature = response.data[i].subgroup.group.feature;
                    if(feature === 'to_user_saldo' || feature === 'aov_particiant_saldo') {
                        this.participants.push(response.data[i]);                        
                        this.totalSaldo += parseFloat(response.data[i].saldo);
                    }
                }

                if(this.participants.length > 0 && !this.loadedBalance) {
                    this.getCustomerData();
                    this.loadedBalance = true;
                }

                $(".loading-icon").fadeOut("slow");
                $("#balance").removeClass("text-transparent");
                $("#balance").addClass("text-light");

                if(isKnab()) {
                    $(".text-white").removeClass("text-white");
                    updateAppearanceKnab();
                }
            });

        $("#previousMonth").on('click', () => {
            if(!this.updatingMonth) {
                this.updatingMonth = true;
                $("#monthTable").fadeTo(FADE_SPEED, 0, () => {
                    this.updateMonths(-1);
                    this.updatingMonth = false;
                });
            }
        });

        $("#nextMonth").on('click', () => {
            if(this.updatingMonth || (this.now.getMonth() === CURRENT_DATE.getMonth() && this.now.getFullYear() === CURRENT_DATE.getFullYear()))
                return false;
            this.updatingMonth = true;
            $("#monthTable").fadeTo(FADE_SPEED, 0, () => {
                this.updateMonths(1);
                this.updatingMonth = false;
            });
        });
    }
}
</script>
